import * as z from "zod/v4";

const channelType = ["REDO", "EBAY", "POSHMARK"] as const;

export const listProducts = {
  name: "listProducts" as const,
  input: z.object({
    products: z.array(
      z.object({
        productId: z.string(),
        variantId: z.string(),
        quantity: z.number().min(1),
        price: z.number().optional(),
        description: z.string().optional(),
      }),
    ),
    channels: z.array(z.enum(channelType)).min(1),
  }),

  output: z.object({
    results: z.array(
      z.object({
        channel: z.enum(channelType),
        success: z.boolean(),
        catalogProductId: z.string().optional(),
        listingId: z.string().optional(),
        listingUrl: z.string().optional(),
        error: z.string().optional(),
      }),
    ),
  }),
};
